import * as React from 'react';
import Button from '@mui/material/Button';
import { WalletButton } from '@txnlab/use-wallet-ui-react';

// All connect buttons render use-wallet-ui's <WalletButton/> — the same component
// the header uses, which owns the full connect → connected → disconnect lifecycle
// via use-wallet. (The previous hand-rolled menu hung on a spinner for some
// wallets.) When `disabled` is set — e.g. a Buy page before the drop opens — we
// show a plain disabled button labeled with `title` instead of the live connector.
// `account`/`onDisconnect` are accepted for call-site compatibility but no longer
// needed: WalletButton tracks the connected wallet and handles disconnect itself.
const ConnectButton = ({ disabled, title, sx }) => {
  if (disabled) {
    return (
      <Button variant="contained" disabled sx={sx}>
        {title || 'Connect Wallet'}
      </Button>
    );
  }
  return <WalletButton />;
};

export default ConnectButton;
